export default "__VITE_ASSET__979cb982__"